import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/api/client";
import { CONTACT } from "@/config/contact";
import { toast } from "sonner";
import { MessageSquare, X, Send, MessageCircle } from "lucide-react";

export default function ChatWidget() {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/leads", { ...form, phone: "", lead_type: "chat", zone: "", property_slug: null });
      setForm({ name: "", email: "", message: "" });
      setOpen(false);
      navigate("/obrigado?type=chat");
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail) || "Erro ao enviar.");
      setSending(false);
    }
  };

  return (
    <>
      {!open && (
        <button
          type="button"
          onClick={() => setOpen(true)}
          data-testid="chat-widget-open"
          aria-label="Abrir chat"
          className="fixed bottom-6 right-24 z-40 inline-flex items-center gap-2 rounded-full bg-white border border-stone-200 pl-4 pr-5 py-3 text-[#103C4A] shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-0.5"
        >
          <MessageSquare className="h-4 w-4" />
          <span className="hidden sm:inline text-sm font-medium">Enviar mensagem</span>
        </button>
      )}

      {open && (
        <div
          data-testid="chat-widget-panel"
          className="fixed bottom-6 right-6 z-50 w-[92vw] sm:w-[380px] card-soft overflow-hidden animate-in fade-in slide-in-from-bottom-4"
        >
          <div className="bg-[#103C4A] text-white px-5 py-4 flex items-center justify-between">
            <div>
              <div className="font-display text-lg">Fale com a Zélia</div>
              <div className="text-xs opacity-80">Resposta no próprio dia útil</div>
            </div>
            <button onClick={() => setOpen(false)} data-testid="chat-widget-close" className="rounded-full p-1 hover:bg-white/10" aria-label="Fechar">
              <X className="h-5 w-5" />
            </button>
          </div>

          <div className="p-5 space-y-4">
            <form onSubmit={submit} className="space-y-3" data-testid="chat-widget-form">
                <input
                  required
                  placeholder="Nome"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  data-testid="chat-name"
                  className="w-full rounded-lg border border-stone-200 bg-white px-3 py-2 text-sm"
                />
                <input
                  required
                  type="email"
                  placeholder="Email"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  data-testid="chat-email"
                  className="w-full rounded-lg border border-stone-200 bg-white px-3 py-2 text-sm"
                />
                <textarea
                  required
                  rows={3}
                  placeholder="Em que posso ajudar?"
                  value={form.message}
                  onChange={(e) => setForm({ ...form, message: e.target.value })}
                  data-testid="chat-message"
                  className="w-full rounded-lg border border-stone-200 bg-white px-3 py-2 text-sm"
                />
                <button type="submit" disabled={sending} data-testid="chat-submit" className="btn-primary w-full">
                  <Send className="h-4 w-4" /> {sending ? "A enviar..." : "Enviar mensagem"}
                </button>
                <div className="text-center text-xs text-stone-500 pt-2 border-t border-stone-100">ou</div>
                <a href={CONTACT.whatsappUrl} target="_blank" rel="noreferrer" data-testid="chat-whatsapp" className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-5 py-2.5 text-sm font-medium text-white">
                  <MessageCircle className="h-4 w-4" /> WhatsApp direto
                </a>
              </form>
          </div>
        </div>
      )}
    </>
  );
}
